import React from 'react';
import type NotFoundErrorPageType from '@atlassian/jira-error-pages/src/ui/not-found-error-page/NotFoundErrorPage.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyNotFoundErrorPage: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof NotFoundErrorPageType
>(
	() =>
		import(
			/* webpackChunkName: "async-error-pages-not-found", jiraSpaEntry: "async-error-pages-not-found" */ '@atlassian/jira-spa-apps-error-pages-not-found'
		),
);

const AsyncNotFoundErrorPage = (): React.JSX.Element => (
	<LazyPage Page={LazyNotFoundErrorPage} pageId="errors-404" shouldShowSpinner={false} />
);

export default AsyncNotFoundErrorPage;
